export function hasUsableDraftEstimate(estimates) {
  const range = estimates?.creditCostEstimateRange;
  const contract = estimates?.draftEstimateContract;
  const hasUsableRange =
    typeof range?.min === "number" &&
    Number.isFinite(range.min) &&
    range.min > 0 &&
    typeof range?.max === "number" &&
    Number.isFinite(range.max) &&
    range.max >= range.min &&
    typeof range?.avg === "number" &&
    Number.isFinite(range.avg) &&
    range.avg > 0 &&
    range.avg >= range.min &&
    range.avg <= range.max;
  const hasUsableContract =
    contract?.version === 1 &&
    typeof contract.id === "string" &&
    contract.id.length > 0 &&
    typeof contract.token === "string" &&
    contract.token.length > 0 &&
    typeof contract.expiresAtMs === "number" &&
    contract.expiresAtMs > Date.now();

  return hasUsableRange && hasUsableContract;
}

export function requireUsableDraftEstimate(estimates) {
  if (!hasUsableDraftEstimate(estimates)) {
    throw new Error("Draft estimate response did not include a usable server contract");
  }

  return estimates;
}

export function buildLocalDraftPreflightResult({ extraInstructionsWordCount, documentSceneCount, estimates }) {
  if (extraInstructionsWordCount > 2000) {
    return {
      reason: "extra-instructions-length",
      response: {
        Analysis: "",
        ApprovaleMessage: "",
        Diagnosis: "For best results, reduce the length of your Extra Instructions.",
        QuickFixCTA: "",
        ResponseType: "Suggestion",
        RewritePrompt: "",
        estimates: { ...estimates },
      },
    };
  }

  if (documentSceneCount > 7) {
    return {
      reason: "document-scene-count",
      response: {
        Analysis: "Client Side Manual Check",
        ApprovaleMessage: "Client Side Manual Check",
        Diagnosis: "Most chapters have just a few scenes, you may notice unusual results with this many scenes.",
        QuickFixCTA: "",
        ResponseType: "Suggestion",
        RewritePrompt: "",
        estimates: { ...estimates },
      },
    };
  }

  return null;
}
